import { color } from "src/styles/globals";
import styled from "styled-components";
import { Title as SundayTitle, Body as SundayBody } from "sunday-component";
import { Modal as AntdModal } from "antd";
import CommonButton from "../Button";

export const Title = styled(SundayTitle).attrs({ level: 5 })`
  margin-top: 4px;
  text-align: center;
  color: ${color.charcoal10};
`;
export const Body = styled(SundayBody).attrs({ level: 7 })`
  margin-top: 8px;
  text-align: center;
  color: ${color.charcoal10};
`;

export const Button = styled(CommonButton).attrs({
  fullWidth: true,
})`
  margin-top: 16px;
`;
export const Modal = styled(AntdModal)`
  .ant-modal-content {
    border-radius: 12px;
  }
  .ant-modal-header {
    border-radius: 12px;
  }
`;
